var map = {
	"./ADC.svg": 519,
	"./AEON.svg": 520,
	"./AMP.svg": 521,
	"./ANC.svg": 522,
	"./ARCH.svg": 523,
	"./ARDR.svg": 524,
	"./AUR.svg": 525,
	"./BANX.svg": 526,
	"./BAT.svg": 527,
	"./BAY.svg": 528,
	"./BC.svg": 529,
	"./BCC.svg": 530,
	"./BCN.svg": 531,
	"./BFT.svg": 532,
	"./BRK.svg": 533,
	"./BRX.svg": 534,
	"./BSD.svg": 535,
	"./BTC.svg": 536,
	"./BTCD.svg": 537,
	"./BTS.svg": 538,
	"./CLAM.svg": 539,
	"./CLOAK.svg": 540,
	"./DAO.svg": 541,
	"./DASH.svg": 542,
	"./DCR.svg": 543,
	"./DCT.svg": 544,
	"./DGB.svg": 545,
	"./DGD.svg": 546,
	"./DGX.svg": 547,
	"./DMD.svg": 548,
	"./DOGE.svg": 549,
	"./EMC.svg": 550,
	"./EOS.svg": 551,
	"./ERC.svg": 552,
	"./ETC.svg": 553,
	"./ETH.svg": 554,
	"./FC2.svg": 555,
	"./FCT.svg": 556,
	"./FLO.svg": 557,
	"./FRK.svg": 558,
	"./FTC.svg": 559,
	"./GAME.svg": 560,
	"./GDC.svg": 561,
	"./GEMZ.svg": 562,
	"./GLD.svg": 563,
	"./GNO.svg": 564,
	"./GNT.svg": 565,
	"./GOLOS.svg": 566,
	"./GRC.svg": 567,
	"./GRS.svg": 568,
	"./HEAT.svg": 569,
	"./ICN.svg": 570,
	"./IFC.svg": 571,
	"./INCNT.svg": 572,
	"./IOC.svg": 573,
	"./IOTA.svg": 574,
	"./JBS.svg": 575,
	"./KMD-alt.svg": 576,
	"./KOBO.svg": 577,
	"./KORE-alt.svg": 578,
	"./LBC.svg": 579,
	"./LDOGE.svg": 580,
	"./LISK.svg": 581,
	"./LTC-alt.svg": 582,
	"./LTC.svg": 583,
	"./MAID.svg": 584,
	"./MCO.svg": 585,
	"./MINT.svg": 586,
	"./MONA.svg": 587,
	"./MRC.svg": 588,
	"./MSC.svg": 589,
	"./MTR.svg": 590,
	"./MUE-alt.svg": 591,
	"./NBT.svg": 592,
	"./NEO.svg": 593,
	"./NEOS.svg": 594,
	"./NEU.svg": 595,
	"./NLG.svg": 596,
	"./NMC.svg": 597,
	"./NOTE.svg": 598,
	"./NVC.svg": 599,
	"./NXT.svg": 600,
	"./OK.svg": 601,
	"./OMG.svg": 602,
	"./OMNI.svg": 603,
	"./OPAL.svg": 604,
	"./PART.svg": 605,
	"./PIGGY.svg": 606,
	"./PINK.svg": 607,
	"./PIVX.svg": 608,
	"./POT.svg": 609,
	"./PPC.svg": 610,
	"./QRK.svg": 611,
	"./RADS.svg": 612,
	"./RBIES.svg": 613,
	"./RBT.svg": 614,
	"./RBY.svg": 615,
	"./RDD.svg": 616,
	"./REP.svg": 617,
	"./RISE.svg": 618,
	"./SAR.svg": 619,
	"./SCOT.svg": 620,
	"./SDC.svg": 621,
	"./SIA.svg": 622,
	"./SJCX.svg": 623,
	"./SLG.svg": 624,
	"./SLS.svg": 625,
	"./SNRG.svg": 626,
	"./START.svg": 627,
	"./STEEM.svg": 628,
	"./STR.svg": 629,
	"./STRAT.svg": 630,
	"./SWIFT.svg": 631,
	"./SYNC.svg": 632,
	"./SYS.svg": 633,
	"./TRIG.svg": 634,
	"./TX.svg": 635,
	"./UBQ.svg": 636,
	"./UNITY.svg": 637,
	"./USD.svg": 638,
	"./USDT.svg": 639,
	"./VIOR.svg": 640,
	"./VNL.svg": 641,
	"./VPN.svg": 642,
	"./VRC.svg": 643,
	"./VTC.svg": 644,
	"./WAVES.svg": 645,
	"./XAI.svg": 646,
	"./XBS.svg": 647,
	"./XCP.svg": 648,
	"./XEM.svg": 649,
	"./XMR.svg": 650,
	"./XPM.svg": 651,
	"./XRP.svg": 652,
	"./XTZ.svg": 653,
	"./XVG.svg": 654,
	"./YBC.svg": 655,
	"./ZEC.svg": 656,
	"./ZEIT.svg": 657,
	"./default.svg": 658
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 518;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/currency-icons ^\.\/.*\.svg$
// module id = 518
// module chunks = 0